import React, { useEffect, useRef } from "react";
import ParticleBackground from "../components/ParticleBackground";

import PowerBtn from "../components/PowerBtn";
import Footer from "../components/Footer";
import styled from "styled-components";
import { motion } from "framer-motion";
import { work } from "../data/Work";
import WorkCard from "../components/WorkCard";
import Menu from "../components/Menu";

const Box = styled.div`
  height: 350vh;
  position: relative;
  display: flex;
  align-items: center;
  @media (max-width: 1024px) {
    height: 400vh;
  }
  @media (max-width: 768px) {
    height: 450vh;
  }
  @media (max-width: 425px) {
    height: 500vh;
  }
`;

const Main = styled(motion.ul)`
  position: fixed;
  top: 20%;
  left: calc(0.5rem + 15vw);
  z-index: 30;
  display: flex;
  color: white;
  @media (max-width: 768px) {
    top: 26%;
    left: calc(3rem + 1vw);
  }
`;

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,

    transition: {
      staggerChildren: 0.5,
      duration: 0.5,
    },
  },
};

const Work = () => {
  const ref = useRef(null);

  useEffect(() => {
    let element = ref.current;

    const rotate = () => {
      element.style.transform = `translateX(${-window.pageYOffset}px)`;
    };

    window.addEventListener("scroll", rotate);
    return () => {
      window.removeEventListener("scroll", rotate);
    };
  }, []);

  return (
    <Box>
      <PowerBtn />
      <Menu />
      <Main ref={ref} variants={container} initial="hidden" animate="show">
        {work.map((x) => (
          <WorkCard key={x.id} data={x} />
        ))}
      </Main>

      <Footer />
      <ParticleBackground />
    </Box>
  );
};

export default Work;
